/* eslint-disable camelcase */
import React from 'react';
import { useSelector } from 'react-redux';
import {
  Row, Col, Card,
} from 'antd';

const TransactionStatsSummary = () => {
  const {
    data,
  } = useSelector(({ processors }) => processors.transStats);

  let totalTransactions = 0;
  const hasSummary = data && data.totalSummary && Object.keys(data.totalSummary).length > 0;

  if (hasSummary) {
    Object.keys(data.totalSummary).map((status) => {
      totalTransactions += data.totalSummary[status].count;
      return totalTransactions;
    });
  }

  const getRating = (count) => {
    const perc = ((count / totalTransactions) * 100);
    return Math.round(perc * 100) / 100;
  };

  const colorStatus = (transactionStatus) => {
    let color = 'default';
    if (transactionStatus === 'COMPLETED' || transactionStatus === 'COMPLETE') {
      color = 'success';
    } else if (transactionStatus === 'FAILED') {
      color = 'error';
    } else if (transactionStatus === 'CONFIRMING') {
      color = 'processing';
    } else if (transactionStatus === 'PENDING') {
      color = 'processing';
    } else if (transactionStatus === 'CANCELLED' || transactionStatus === 'CANCELLED') {
      color = 'warning';
    }

    return (
      <span className="ant-badge ant-badge-status ant-badge-not-a-wrapper">
        <span className={`ant-badge-status-dot ant-badge-status-${color}`} />
        <span className="ant-badge-status-text">{transactionStatus}</span>
      </span>
    );
  };

  return (
    <>
      {hasSummary
        && (
        <>
          <br />
          <br />
          <Card>
            {Object.keys(data.totalSummary).map((status) => (
              <>
                <Row>
                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div>{colorStatus(status)}</div>
                    <small>
                      {new Intl.NumberFormat().format(data.totalSummary[status].count)}
                      {' '}
                      Transactions
                    </small>
                  </Col>
                  <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                    <div style={{ marginBottom: '7px' }}>
                      {new Intl.NumberFormat().format(data.totalSummary[status].value)}
                      {' '}
                      {data.currency}
                    </div>
                    <small>
                      Rate:
                      {' '}
                      {getRating(data.totalSummary[status].count)}
                      %
                    </small>
                  </Col>
                </Row>
                <br />
              </>
            ))}
          </Card>
        </>
        )}
    </>
  );
};

export default TransactionStatsSummary;
